@if (control) {
  <div *ngIf="control?.errors && control?.dirty">
    <small class="p-error">{{ errorMessage | translate }}</small>
  </div>
} @else {
  <div *ngIf="formGroup?.errors && formGroup?.dirty">
    <small class="p-error">{{ errorMessage | translate }}</small>
  </div>
}
